import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const deleteReviewAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/admin/reviews/:reviewId'
};

export const deleteMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/admin/mymes/:mymeId'
};

export const deleteUserAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/admin/users/:userId'
};

export const approveSingleReviewReportAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/reviews/:reviewId/:userReportId'
};

export const approveAllReportedReviewsAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/reviews/:reviewId/approve-reports'
};

export const lockUserAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/users/:userId/lock-user'
};

export const unlockUserAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/users/:userId/unlock-user'
};

export const changeSubscriptionStatusForUserAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/users/:userId'
};

export const approveSingleMymeReportAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/mymes/:mymeId/:userReportId'
};

export const approveAllReportedMymesAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/admin/mymes/:mymeId/approve-reports'
};

export const getAllUsersAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/users',
  cacheKeys: ['getAllUsers']
};

export const getReportListForReviewAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/reviews/:reviewId',
  cacheKeys: ['getReportListForReviewAPI']
};

export const getAllSuperadminCommentsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/reviews',
  cacheKeys: ['getAllSuperadminCommentsAPI']
};

export const getReportedSuperadminReviewsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/reviews/reported',
  cacheKeys: ['getReportedSuperadminReviewsAPI']
};

export const getReportedReviewDetailsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/reviews/:reviewId/details',
  cacheKeys: ['getReportedReviewDetailsAPI']
};

export const getAllSuperadminMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/mymes',
  cacheKeys: ['getAllSuperadminMymesAPI']
};

export const getReportedSuperadminMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/mymes/reported',
  cacheKeys: ['getReportedSuperadminMymesAPI']
};

export const getReportListForMymeAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/mymes/:mymeId',
  cacheKeys: ['getReportListForMymeAPI']
};

export const getReportedMymeDetailsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/mymes/:mymeId/details',
  cacheKeys: ['getReportedMymeDetailsAPI']
};

export const getAllSuperadminAccountsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/admin/accounts',
  cacheKeys: ['getAllSuperadminAccountsAPI']
};
